import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DEFAULT_FILE, MAX_FILE_SIZE } from 'src/app/modules/instance/constants';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    standalone: false,
    selector: 'app-file-chooser-subform',
    templateUrl: './file-chooser-subform.component.html',
    styleUrls: ['./file-chooser-subform.component.scss']
})
export class FileChooserSubformComponent implements OnInit {
    listForm: FormGroup;

    @Output()
    formReady = new EventEmitter<FormGroup>();

    constructor(private readonly formBuilder: FormBuilder, private readonly snackBar: MatSnackBar) {}

    get isDefaultFile(): boolean {
        return !!_.get(this, 'listForm.value.file.isDefault', false);
    }

    ngOnInit(): void {
        this.listForm = this.formBuilder.group({
            file: {}
        });
        this.setupEmptyFile();
        this.formReady.emit(this.listForm);
    }

    setupEmptyFile() {
        this.listForm.controls.file.setValue(DEFAULT_FILE);
    }

    public uploadFile(event) {
        const file = event.target.files[0];
        if (file.size > MAX_FILE_SIZE) {
            this.snackBar.open(`Cannot attach file larger than 6Mb`, 'OK', {
                verticalPosition: 'top',
                horizontalPosition: 'center',
                duration: 3000
            });
            return;
        }
        this.listForm.controls.file.setValue(file);
    }

    static getQueryParams(formGroup: any) {
        return {
            file: formGroup['file']
        };
    }
}
